import { useEffect } from "react";

export default function SEO({ title, description, path = "/" }) {
  useEffect(() => {
    document.title = title;
    const setMeta = (selector, attr, content) => {
      let el = document.head.querySelector(selector);
      if (!el) {
        el = document.createElement("meta");
        if (selector.includes("property")) {
          el.setAttribute("property", selector.match(/"(.+)"/)[1]);
        } else {
          el.setAttribute("name", selector.match(/"(.+)"/)[1]);
        }
        document.head.appendChild(el);
      }
      el.setAttribute(attr, content);
    };
    setMeta('meta[name="description"]', "content", description);
    setMeta('meta[property="og:title"]', "content", title);
    setMeta('meta[property="og:description"]', "content", description);
    setMeta('meta[property="og:url"]', "content", `https://airconditioningvictoria.com.au${path}`);
    let canonical = document.head.querySelector('link[rel="canonical"]');
    if (!canonical) {
      canonical = document.createElement("link");
      canonical.setAttribute("rel", "canonical");
      document.head.appendChild(canonical);
    }
    canonical.setAttribute("href", `https://airconditioningvictoria.com.au${path}`);

    const NAMES = {
      "/ducted-air-conditioning": "Ducted Air Conditioning",
      "/split-system-air-conditioning": "Split System Air Conditioning",
      "/multi-head-split-systems": "Multi-Head Systems",
      "/veu-rebates": "VEU Rebates",
      "/warranty": "Warranty",
      "/about": "About",
      "/contact": "Contact",
      "/privacy-policy": "Privacy Policy",
      "/terms": "Terms & Conditions",
    };
    let bc = document.getElementById("breadcrumb-ld");
    if (NAMES[path]) {
      if (!bc) {
        bc = document.createElement("script");
        bc.type = "application/ld+json";
        bc.id = "breadcrumb-ld";
        document.head.appendChild(bc);
      }
      bc.textContent = JSON.stringify({
        "@context": "https://schema.org",
        "@type": "BreadcrumbList",
        itemListElement: [
          { "@type": "ListItem", position: 1, name: "Home", item: "https://airconditioningvictoria.com.au/" },
          { "@type": "ListItem", position: 2, name: NAMES[path], item: `https://airconditioningvictoria.com.au${path}` },
        ],
      });
    } else if (bc) {
      bc.remove();
    }
  }, [title, description, path]);

  return null;
}
